import {
  storeUserPool,
  renderApplication,
} from "../../SessionManagement/actionCreators"

export const mapState = (state) => ({
  protocols: state.sessionReducer.protocols,
})

export const mapDispatch = (dispatch) => ({
  storeUserPool: (...args) => dispatch(storeUserPool(...args)),
  renderApplication: () => dispatch(renderApplication()),
})
